module.exports = __webpack_public_path__ + "img/iot1.482aeda0.png";